var _rect, _line, _polyline, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-color-main",
    x: 26.317,
    y: 36.438,
    width: 147.366,
    height: 147.366
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 26.317,
    y1: 69.234,
    x2: 173.683,
    y2: 69.234
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "stroke-color-main",
    points: "79.071 122.773 100.717 101.128 100.717 164.5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 58.963,
    y1: 34.933,
    x2: 58.963,
    y2: 10.696
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "stroke-color-main",
    x1: 140.486,
    y1: 34.933,
    x2: 140.486,
    y2: 10.696
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.a0e770684d8d420379bce6908ee581be.svg";
export { ForwardRef as ReactComponent };